import {Injectable} from 'ng-metadata/core';
import {AbstractRequest} from './abstractRequest';
import {FormBuilderEnums} from '../../../../../../infra/formBuilder/formBuilder.service';
import {YesOrNo} from '../../../../../../infra/formBuilder/field/formField.interface';
import { MappingTablesCache } from '../../../../../../mappingTablesCache/mappingTablesCache.service';
import { ConfigurationUtil } from '../../../../../../nddUtils/configurationUtil.service';

@Injectable()
export class IllRequest extends AbstractRequest {
	constructor(
		private mappingTablesCache : MappingTablesCache,
        private configurationUtil:ConfigurationUtil
	) {
		super();
		//noinspection TypeScriptValidateTypes
		this.formFields =

			[
				{
					key: 'allowed_media',
					name: 'allowed_media',
					label: 'illrequest.label.allowed_media',
                    path: 'allowed-media',
                    mandatory: true,
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
					uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
					populator: {
						func: this.itemsArrayPopulator.bind(this),
						params: {
							key: 'key',
							value: 'value',
                            defaultValue: FormBuilderEnums.FIRST
						}
 					}
				},
				{
					key: 'service_level',
					name: 'service_level',
					label: 'illrequest.label.service_level',
                    path: 'service-level',
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
					uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
					populator: {
						func: this.itemsArrayPopulator.bind(this),
                        params: {
                            defaultValue: FormBuilderEnums.FIRST,
                            key: 'key',
                            value: 'value'
                        }
					}
				},
				{
					key: 'delivery_method',
					name: 'delivery_method',
					label: 'illrequest.label.delivery_method',
                    path: 'delivery-method',
                    mandatory: true,
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
					uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
					populator: {
						func: this.itemsArrayPopulator.bind(this),
                        params: {
                            defaultValue: FormBuilderEnums.FIRST,
                            key: 'key',
                            value: 'value'
                        }
					}
				},
				{
					key: 'ill-unit',
					name: 'ill_unit',
					label: 'illrequest.label.ill_unit',
                    path: 'ill-unit',
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
					uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
					populator: {
						func: this.itemsArrayPopulator.bind(this),
						params: {
							key: 'key',
							value: 'value',
                            defaultValue: FormBuilderEnums.FIRST
						}
					}
				},
				{
					key: 'ill-pickup-locations',
					name: 'pickup_location',
					label: 'illrequest.pickup_location',
					path: 'ill-pickup-locations/{'+FormBuilderEnums.FIELD+':ill_unit}',
                    mandatory: true,
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
					uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
					populator: {
						func: this.itemsArrayPopulator.bind(this),
						params: {
							key: 'key',
							value: 'value'
						}
					}
				},
				{
					key: 'request_year',
					name: 'request_year',
					label: 'illrequest.label.year',
					mandatory: true,
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
					uiType: FormBuilderEnums.UI_TYPE.TEXT
				},
				{
					key: 'last_interest_date',
					name: 'last_interest_date',
					label: 'illrequest.label.last_interest_date',
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.DATE,
					uiType: FormBuilderEnums.UI_TYPE.DATE,
                    populator: {
                        params: {
                            defaultValue: FormBuilderEnums.TODAY,
                            allow       : FormBuilderEnums.FUTURE_DATES
                        }
                    }
                    
				},
				{
					key: 'willing_to_pay',
					name: 'willing_to_pay',
					label: 'illrequest.label.willing_to_pay',
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
					uiType: FormBuilderEnums.UI_TYPE.RADIO_BUTTON,
                    populator: {
                        params: {
                            defaultValue: 'N'
                        }
                    },
					options: YesOrNo()
				},
				{
					key: 'send_directly',
					name: 'send_directly',
					label: 'illrequest.label.send_directly',
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
					uiType: FormBuilderEnums.UI_TYPE.RADIO_BUTTON,
                    populator: {
                        params: {
                            defaultValue: 'Y'
                        }
                    },
					options: YesOrNo()
				},
				{
					key: 'language',
					name: 'language',
					label: 'illrequest.label.language',
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
					uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
					populator: {
						func: this.itemsArrayPopulator.bind(this),
                        params: {
                            key: 'key',
                            value: 'value',
                            defaultValue: FormBuilderEnums.FIRST
                        }
					}
				},
				{
					key: 'request_author',
					name: 'request_author',
					label: 'illrequest.label.author',
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
					uiType: FormBuilderEnums.UI_TYPE.TEXT
				},
				{
					key: 'request_title',
					name: 'request_title',
					label: 'illrequest.label.title',
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
					uiType: FormBuilderEnums.UI_TYPE.TEXT
				},
				{
					key: 'request_volume',
					name: 'request_volume',
					label: 'illrequest.label.volume',
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
					uiType: FormBuilderEnums.UI_TYPE.TEXT
				},
				{
					key: 'request_pages',
					name: 'request_pages',
					label: 'illrequest.label.pages',
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
					uiType: FormBuilderEnums.UI_TYPE.TEXT
				},
                {
                    key: 'patron_note_1',
                    name: 'patron_note_1',
                    label: 'illrequest.label.note',
                    value: '',
                    fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                    uiType: FormBuilderEnums.UI_TYPE.TEXT
                },
 				{
					key: 'request_month',
					name: 'request_month',
					label: 'illrequest.label.month',
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
					uiType: FormBuilderEnums.UI_TYPE.TEXT
				},
				{
					key: 'request_day',
					name: 'request_day',
					label: 'illrequest.label.day',
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
					uiType: FormBuilderEnums.UI_TYPE.TEXT
				},
				{
					key: 'request_issue',
					name: 'request_issue',
					label: 'illrequest.label.issue',
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
					uiType: FormBuilderEnums.UI_TYPE.TEXT
				},
				{
					key: 'copyright',
					name: 'copyright',
					label: '',
					headline: 'nui.illrequest.copyright.sub_title',
					mandatory: true,
					value: '',
					fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
					uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
					options:[
						{
							label:'nui.illrequest.copyright.message',
							value:'Y'
						}
					]
				}
			];
	}

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/illRequest.ts